interface EventCache {
  [eventName: string]: Function[];
}

const eventCache: EventCache = {};

export function emit(name: string, payload?: any) {
  if (eventCache[name]) {
    eventCache[name].forEach((fn) => {
      try {
        fn(payload);
      } catch (e) {
        console.error(e);
      }
    });
  }
}

export function on(name: string, fn: Function) {
  eventCache[name] = eventCache[name] || [];
  eventCache[name].push(fn);
  return fn;
}

/**
 * 卸载指定事件的某个监听函数，或者卸载所有监听函数
 * @param name 需要卸载的事件函数名
 * @param fn 需要卸载的监听函数，如果不提供，则卸载所有监听函数
 */
export function off(name: string, fn?: Function) {
  if (!fn) {
    delete eventCache[name];
    return;
  }
  if (!eventCache[name]) {
    return;
  }
  const index = eventCache[name].indexOf(fn);
  if (index >= 0) {
    eventCache[name].splice(index, 1);
  }
}

/**
 * 统计指定的事件有多少监听函数
 */
export function count(name: string) {
  if (!name) {
    return -1;
  }
  if (!eventCache[name]) {
    return 0;
  }
  return eventCache[name].length;
}
